import { Meta } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import SvgImage from 'components/svgImage/SvgImage';
import React from 'react';
import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

export type InfoIcon = {
  icon: string | React.ReactNode;
  rotate?: boolean;
  separator?: 1 | 2 | 3;
};

type InfoProps = InfoIcon & {
  last: boolean;
  text: string | React.ReactElement;
};

const IconWithDots = styled.View`
  align-items: center;
  flex-direction: column;
  gap: 3px;
`;

const IconInfoRow = styled.View`
  flex-direction: row;
  gap: 14px;
  margin-bottom: 3px;
`;

const TextShrink = styled.View`
  flex-shrink: 1;
  margin-top: 3px;
`;

const styles = StyleSheet.create({
  rotate: {
    transform: [{ rotateY: '180deg' }],
  },
});

const Info: React.FC<InfoProps> = ({
  icon,
  text,
  rotate,
  last,
  separator = 1,
}) => {
  const separatorHeight = () => {
    if (separator === 2) {
      return 25;
    }
    if (separator === 3) {
      return 50;
    }
    return 15;
  };

  return (
    <IconInfoRow>
      {typeof icon === 'string' ? (
        <IconWithDots style={rotate ? styles.rotate : undefined}>
          <Icon size="l" name={icon} />
          {!last && (
            <SvgImage
              width={10}
              height={separatorHeight()}
              name={`Separator-Dots-${separator}`}
            />
          )}
        </IconWithDots>
      ) : (
        icon
      )}
      <TextShrink>
        <Meta>{text}</Meta>
      </TextShrink>
    </IconInfoRow>
  );
};

export default Info;
